import { svgName } from './create-svg'
import { elementFromString } from './element-from-string'
import { wrapChildren } from './wrap'

function addToPageSvg (symbolEle) {
  let pageSvg = document.getElementById('page-svg-icons')
  if (!pageSvg) {
    pageSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    pageSvg.setAttributeNS(null, 'id', 'page-svg-icons')
    pageSvg.setAttributeNS(null, 'style', 'position:absolute;height:0;width:0;')
    pageSvg.appendChild(symbolEle)
    document.body.insertBefore(pageSvg, document.body.firstChild)
  } else {
    pageSvg.appendChild(symbolEle)
  }
}

function svgExists (id) {
  const pageSvg = document.getElementById('page-svg-icons')
  if (!pageSvg) {
    return false
  }
  const svg = pageSvg.querySelector(id)
  return svg != null
}

function getFilename (url) {
  return url.substring(url.lastIndexOf('/svg/') + 5, url.lastIndexOf('.')).replace(/\//g, '_')
}

/**
 * Function to create an SVG icon on the current page
 * @param {string} url The URL of the SVG icon
 * @param {string} pathData The path data of the SVG icon
 */
export function createPageIcon (url, pathData, viewBox = '0 0 32 32') {
  const id = svgName(getFilename(url))
  if (!svgExists(id)) {
    const svgEle = elementFromString(`<svg xmlns="http://www.w3.org/2000/svg">${pathData}</svg>`)
    const symbolEle = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')
    symbolEle.setAttributeNS(null, 'id', id.substring(1))
    symbolEle.setAttributeNS(null, 'viewBox', viewBox)
    wrapChildren(svgEle, symbolEle)
    addToPageSvg(symbolEle)
  }
}

/**
 * Function to add an SVG icon to the current page
 * @param {string} id The identifier of the SVG icon
 * @param {Element} symbolElement The SVG <code>&lt;symbol&gt;</code> element
 */
export function addPageIcon (id, symbolElement) {
  if (!svgExists(id)) {
    addToPageSvg(symbolElement)
  }
}
